module.exports = __webpack_public_path__ + "img/scac.377ca8fc.png";